import Image from 'next/image';

type MobileMenuTriggerProps = {
  isMobileMenuOpen: boolean;
  onToggleMobileMenu: () => void;
}

export const MobileMenuTrigger = ({ isMobileMenuOpen, onToggleMobileMenu }: MobileMenuTriggerProps) => {
  return (
    <button
      aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
      onClick={onToggleMobileMenu}
      className="button button-size-circle-medium button-mobile-menu-trigger flex items-center justify-center"
    >
      {isMobileMenuOpen ? (
        <Image
          width={18}
          height={18}
          className="block"
          src="https://front.com/webassets/rebrand/icon-header-mobile-menu-close.svg"
          alt="Close mobile menu"
        />
      ) : (
        <Image
          width={19}
          height={14}
          className="block"
          src="https://front.com/webassets/rebrand/icon-header-mobile-menu-trigger.svg"
          alt="Mobile menu"
        />
      )}
    </button>
  )
}
